<template>
  <div>
    <div class="top">
      <div class="search">
        <div class="left">
          <img src="@/assets/icon／搜索.png" alt="" class="search_icon" />
          <van-field
            v-model.trim="queryParam.no"
            placeholder="搜索流水号"
            :border="false"
            :clearable="true"
          />
        </div>
        <div class="rig" @click="orderQuery">搜索</div>
      </div>
    </div>

    <van-sticky>
      <van-tabs v-model="active">
        <van-tab
          :title="item.name"
          v-for="item in billTypeArr"
          :key="item.value"
        ></van-tab>
      </van-tabs>
    </van-sticky>
    <van-list
      v-if="billListData.length > 0"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      loading-text="加载中"
      @load="onLoad"
      :immediate-check="false"
    >
      <div class="bill_list">
        <div class="list_in">
          <div
            class="bill_list_item"
            v-for="item in billListData"
            :key="item.id"
          >
            <div class="item_top">
              <div class="top_left">
                {{ billType[item.type] }}
              </div>
              <div class="top_rig">
                {{ item.amount }}
              </div>
            </div>
            <div class="item_bot">
              <div class="time">
                {{ formatDate(item.createTime) }}
              </div>
              <div class="no">
                流水号：{{ item.no }}

                <div class="copy" @click="copyInfo(item, 'no', '.input')">
                  复制
                </div>
                <input type="text" class="input" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <van-empty v-else description="暂无数据" />
  </div>
</template>

<script>
import Vue from 'vue';
import { billList } from '@/api';
import { billType, jsonToArray, formatDate } from '@/utils/util';
export default {
  watch: {
    active: {
      handler(newVal) {
        this.billListData = [];
        this.page.pageNum = 1;
        this.loading = false;
        this.finished = false;
        const type = this.billTypeArr[newVal].value;
        if (type == 'all') {
          const { type, ...params } = this.queryParam;
          this.queryParam = params;
        } else {
          this.queryParam.type = type;
        }
        this.getBillList();
      },
      immediate: true,
      deep: true
    }
  },

  data() {
    return {
      active: 0,
      billType: billType,
      billTypeArr: [
        {
          value: 'all',
          name: '全部明细'
        },
        {
          value: 'RECHARGE',
          name: '充值'
        },
        {
          value: 'EXPENSE',
          name: '消费'
        },
        {
          value: 'INCOME',
          name: '收入'
        },
        {
          value: 'WITHDRAW',
          name: '提现'
        },
        {
          value: 'MANUAL',
          name: '管理员转账'
        },
        {
          value: 'REFUND',
          name: '退款'
        }
      ],
      loading: false,
      finished: false,
      list: [],
      page: {
        pageNum: 1,
        pageSize: 20
      },
      queryParam: {},
      billListData: []
    };
  },

  methods: {
    formatDate,
    copyInfo(record, key, inputClass) {
      var input = document.querySelector(inputClass);
      input.value = record[key];
      input.select(); // 选中文本
      input.setSelectionRange(0, input.value.length);
      document.execCommand('copy'); // 执行浏览器复制命令
      this.$toast.success('复制成功');
    },

    getBillList() {
      billList(Object.assign(this.queryParam, this.page)).then((res) => {
        if (res.success) {
          //数据拼接
          this.billListData = [...this.billListData, ...res.data.list];
          //加载为fasle
          this.loading = false;
          //数据总数等于数组长度  数据加载完毕
          if (res.data.page.total == this.billListData.length) {
            this.finished = true;
          }
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    onLoad() {
      this.page.pageNum++;
      this.getBillList();
    },
    orderQuery() {
      this.billListData = [];
      this.page.pageNum = 1;
      this.loading = false;
      this.finished = false;
      this.getBillList();
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .van-list__finished-text {
  background-color: #f7f8fa;
}
.top {
  .search {
    height: 14.933vw;
    padding: 2.667vw 3.2vw 2.133vw;
    display: flex;
    align-items: center;
    .left {
      flex: 1;
      display: flex;
      align-items: center;

      background-color: #f7f8fa;
      border-radius: 4.8vw;
      .search_icon {
        margin-left: 3.2vw;
        width: 6.4vw;
        height: 6.4vw;
      }
    }
    .rig {
      font-size: 4.533vw;
      color: rgba(0, 0, 0, 0.65);
      margin-left: 3.2vw;
    }
  }
}
.bill_list {
  background-color: #f7f8fa;
  padding: 3.2vw 3.2vw;
  min-height: calc(100vh - 100px);

  .list_in {
    padding: 0 3.2vw;
    border-radius: 2.133vw;
    background-color: #fff;
  }
  .bill_list_item {
    padding: 4.533vw 0 2.133vw;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    &:last-child {
      border: 0;
    }
    .item_top {
      display: flex;
      justify-content: space-between;
      margin-bottom: 2.133vw;
      .top_left {
        font-size: 4vw;
        color: #333333;
      }

      .top_rig {
        font-size: 4.533vw;
        color: #333333;
      }
    }

    .item_bot {
      .time {
        font-size: 3.2vw;
        color: rgba(0, 0, 0, 0.45);
        margin-bottom: 2.133vw;
      }

      .no {
        display: flex;
        align-items: center;
        font-size: 3.2vw;
        color: rgba(0, 0, 0, 0.45);
        margin-bottom: 2.133vw;
        .copy {
          font-size: 3.2vw;
          color: #f93244;
          padding: 0 3.2vw;
        }
      }
    }
  }
}
/deep/ .van-cell {
  background-color: transparent;
  padding: 1.6vw 3.2vw 1.6vw 1.067vw;
}
.input {
  width: 1.333vw;
  height: 1.333vw;
  opacity: 0;
}
</style>
